import { useMatch, useParams } from 'react-router'
import { H4 } from '@/components/sv/typographies'
import { Button } from '@/components/ui/button'
import { CardAction, CardDescription, CardHeader } from '@/components/ui/card'
import { useCompanyPath } from '@/lib/hooks'
import { DeleteWebhookDialog } from '@/routes/webhook/tabs/overview/sections/danger-zone/delete-webhook/delete-webhook-dialog'

export const DeleteWebhook = () => {
  const { idWebhook = '' } = useParams()
  const { navigateToPath } = useCompanyPath()
  const isDeleteDialogOpen = Boolean(
    useMatch('/webhook/:idWebhook/overview/delete')
  )

  return (
    <>
      <CardHeader className="py-6 pb-0">
        <H4>Delete webhook</H4>
        <CardDescription>
          When you delete an webhook, we delete all of its data.{' '}
          <strong>
            We cannot undo this action or retrieve the data later.
          </strong>
        </CardDescription>
        <CardAction>
          <Button
            variant="destructive"
            onClick={() =>
              navigateToPath({
                pathname: '/webhook/:idWebhook/overview/delete',
                variables: { idWebhook },
                options: { replace: true },
              })
            }
          >
            Delete webhook
          </Button>
        </CardAction>
      </CardHeader>
      <DeleteWebhookDialog
        isOpen={isDeleteDialogOpen}
        onClose={() =>
          navigateToPath({
            pathname: '/webhook/:idWebhook/overview',
            variables: { idWebhook },
            options: { replace: true },
          })
        }
      />
    </>
  )
}
